import type { EventListFilters } from './event-list-table.types';

export const EVENT_LIST_FILTER_ALL = 'All' as const;

export function countActiveEventListFilters(
  filters: Pick<
    EventListFilters,
    'day' | 'tag' | 'room' | 'instructor' | 'session' | 'showArchivedEvents'
  >,
): number {
  try {
    let count = 0;
    if (filters.day !== EVENT_LIST_FILTER_ALL) count += 1;
    if (filters.tag !== EVENT_LIST_FILTER_ALL) count += 1;
    if (filters.room !== EVENT_LIST_FILTER_ALL) count += 1;
    if (filters.instructor !== EVENT_LIST_FILTER_ALL) count += 1;
    if (filters.session !== EVENT_LIST_FILTER_ALL) count += 1;
    if (filters.showArchivedEvents) count += 1;
    return count;
  } catch (error) {
    console.error('Failed to count active event filters', { filters, error });
    throw error;
  }
}
